import React from 'react';
import { LazyRouteConfig } from './types';

// Lazy load super admin pages
const SuperAdmin = React.lazy(() => import('@/pages/SuperAdmin'));
const CompanyOverviewPage = React.lazy(() => import('@/pages/superadmin/CompanyOverviewPage'));
const UsageAnalytics = React.lazy(() => import('@/pages/superadmin/UsageAnalytics'));
const CustomerHealth = React.lazy(() => import('@/pages/superadmin/CustomerHealth'));
const Notifications = React.lazy(() => import('@/pages/superadmin/Notifications'));
const AdminTools = React.lazy(() => import('@/pages/superadmin/AdminTools'));
const AssessmentModelTesting = React.lazy(() => import('@/pages/superadmin/AssessmentModelTesting'));
const SessionDetails = React.lazy(() => import('@/pages/superadmin/SessionDetails'));
const ValidationModule = React.lazy(() => import('@/pages/superadmin/ValidationModule'));
const CognitiveDistribution = React.lazy(() => import('@/pages/superadmin/CognitiveDistribution'));
const AssessmentTranslations = React.lazy(() => import('@/pages/AssessmentTranslations'));

export const superAdminRoutes: LazyRouteConfig[] = [
  { path: '/superadmin', component: CompanyOverviewPage, requireSuperAdmin: true },
  { path: '/superadmin/users', component: SuperAdmin, requireSuperAdmin: true },
  { path: '/superadmin/usage', component: UsageAnalytics, requireSuperAdmin: true },
  { path: '/superadmin/health', component: CustomerHealth, requireSuperAdmin: true },
  { path: '/superadmin/sessions', component: SessionDetails, requireSuperAdmin: true },
  { path: '/superadmin/validation', component: ValidationModule, requireSuperAdmin: true },
  { path: '/superadmin/cognitive', component: CognitiveDistribution, requireSuperAdmin: true },
  { path: '/superadmin/notifications', component: Notifications, requireSuperAdmin: true },
  { path: '/superadmin/tools', component: AdminTools, requireSuperAdmin: true },
  { path: '/testing', component: AssessmentModelTesting, requireSuperAdmin: true },
  { path: '/assessmentstranslations', component: AssessmentTranslations, requireSuperAdmin: true },
];
